import React, { useState, useEffect, createContext } from 'react';
import AdminDashboardCard from '../../components/AdminDashboardCard/AdminDashboardCard';
import threePeople_icon from '../../images/icons/threePeople_icon.svg';
import dashboardRupee_icon from '../../images/icons/dashboardRupee_icon.svg';
import newBP_icon from '../../images/icons/newBP_icon.svg';

import moment from 'moment';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import Table from '../../components/Table/RsponsiveTable';

import TopBarFiltersForRm from '../../components/TopbarFiltersForRm/TopbarFiltersForRm';
import './AdminDashboard.css';
import AssignBPColumn from '../AssignBP/AssignBPColumn';
import {
  getListPartner,
  getAdminCardsData,
  serachBP
} from '../../common/constants/api';
import { getFiltersInfo } from '../../common/utils/FiltersInfo';

let cardStaticData = {
  totalBp: {
    count: 0,
    status: 'Total Business Partners',
    icon: threePeople_icon
  },
  transactingBp: {
    count: 0,
    status: 'Transacting Business Partners',
    icon: dashboardRupee_icon
  },
  newBp: {
    count: 0,
    status: 'New BPs Enrolled',
    icon: newBP_icon
  }
};
let fromDate;
let toDate;
export const FromDateRange = () => {
  return fromDate;
};
export const toDateRange = () => {
  return toDate;
};

export const StateExporterBp = createContext();

const AdminDashboard = ({ showAddLeadButtonInBPList = true }) => {
  const [TableData, setTableData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [startDate, setStartDate] = useState(
    getFiltersInfo()?.startDate || moment().format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(
    getFiltersInfo()?.endDate || moment().format('YYYY-MM-DD')
  );
  const [tableLoading, setTableLoading] = useState(true);
  const [tabledataLoading, setTabledataLoading] = useState(true);
  const [rmId, setRmId] = useState(getFiltersInfo()?.selectedRm || '');
  const [tableInfo, setTableInfo] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    fromDate = startDate;
    toDate = endDate;
    getAdminCardsData(startDate, endDate)
      .then(res => {
        Object.keys(res).map(each => {
          if (cardStaticData[each]) {
            cardStaticData[each] = {
              ...cardStaticData[each],
              count: res[each]
            };
          }
        });

        setCardData(cardStaticData);
      })
      .catch(err => {});
  }, [startDate, endDate]);

  const getPartnerList = () => {
    setTabledataLoading(true);
    getListPartner(
      page,
      pageSize,
      startDate,
      endDate,
      'createdOn',
      'desc',
      rmId
    )
      .then(data => {
        setTableInfo(data?.dataPage);
        if (Array.isArray(data?.data)) {
          setTableData(data?.data);
        } else {
          setTableData([]);
        }
        setTabledataLoading(false);
      })
      .catch(err => {
        setTableData([]), setTabledataLoading(false);
      });
  };

  useEffect(() => {
    setTabledataLoading(true);
    getPartnerList();
  }, [startDate, endDate, rmId, page, pageSize]);

  const customHandlePageChange = page => {
    setPage(page - 1);
  };

  const customHandlePerRowsChange = (perPage, page) => {
    setPageSize(perPage);
    setPage(0);
  };

  return (
    <React.Fragment>
      <Helmet title={`Dashboard Business Partner | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className="  min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1 w-full">
            <Header />
            <StateExporterBp.Provider
              value={{
                startDate,
                setStartDate,
                endDate,
                setEndDate,
                bp: true
              }}
            >
              <TopBarFiltersForRm hideAddLeadBtn={!showAddLeadButtonInBPList} />
            </StateExporterBp.Provider>
            <div className="test w-full ">
              <div className="cardsContainer">
                {cardStaticData !== null && (
                  <>
                    <AdminDashboardCard sendeach={cardStaticData.totalBp} />
                    <AdminDashboardCard
                      sendeach={cardStaticData.transactingBp}
                    />
                    <AdminDashboardCard sendeach={cardStaticData.newBp} />
                  </>
                )}

                {!cardStaticData ||
                  (cardStaticData &&
                    Object.keys(cardStaticData).length === 0 && (
                      <p className="text-red-300">Something went wrong</p>
                    ))}
              </div>
            </div>

            <div>
              <Table
                rm
                rmId={rmId}
                setRmId={setRmId}
                data={TableData}
                columns={AssignBPColumn(rmId, getPartnerList)}
                startDate={startDate}
                endDate={endDate}
                tableLoading={tabledataLoading}
                searchUrl={serachBP}
                filterFunction
                searchName="partnerCode"
                serchBarPlaceHolder="Search by name, Partner code or Mobile no"
                tableListbelongs="Business partners"
                serverPagination
                serverPaginationUrl={getListPartner}
                TableInfo={tableInfo}
                rows={pageSize}
                CustomhandlePerRowsChange={customHandlePerRowsChange}
                CustomhandlePageChange={customHandlePageChange}
                filterComponent={false}
                page={tableInfo?.number || 0}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminDashboard;
